import { Injectable } from "@angular/core";
import {
  PRIMITIVE,
  ServiceMessageBrokerFactory,
  ServiceMessageBroker,
} from "shared/provider-webworker";

import { SystemControlLookupService } from "./SystemControlLookupService";
import { PrimaryLookupService } from "../../impl/PrimaryLookupService";
import { ModelUpdate } from "../../impl/ModelUpdate";
import { IBasePrimeDependent } from "../../IBasePrimeDependent";
import { ISystemControlPromiseLookupService } from "../ISystemControlPromiseLookupService";
import { BaseLookupService } from "../../impl/BaseLookupService";
import { PromiseSet } from "../../../promise/PromiseSet";
import { Observable, Subject, ReplaySubject } from "rxjs";

import { CubiqWorker } from "../../../worker/CubiqWorker";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import {
  SystemControlUpdateRequest,
  SystemControlUpdateRequestImpl,
} from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class SystemControlPrimaryLookupService
  extends PrimaryLookupService<string, CubiqTS.SystemControlImpl>
  implements ISystemControlPromiseLookupService
{
  constructor(
    protected base: SystemControlLookupService,
    factory: ServiceMessageBrokerFactory,
    cubiqWorker: CubiqWorker,
  ) {
    super(
      base,
      factory,
      CubiqTS.SystemControlImpl,
      cubiqWorker,
      "SystemControlImpl",
      CubiqTS.SystemControlImpl,
    );
    cubiqWorker.isAuth(`${this.constructor.name}`).then(
      () => {
        let systemControlObservable = cubiqWorker.primeStaticData<CubiqTS.SystemControlImpl>(
          CubiqTS.SystemControlImpl.name,
        );

        systemControlObservable.subscribe(
          (systemControls: CubiqTS.SystemControlImpl[]) => {
            this.base.prime(systemControls);
          },
          (error: Error) => {
            console.debug("SystemControl prime failed");
            this._primed.reject(error);
          },
          () => {
            this._primed.resolve(true);
          },
        );
      },
      (reason) => {
        console.debug("SystemControlPrimaryLookupService: Failed to prime: " + reason);
        this._primed.resolve(false);
      },
    );
    this.broker.registerMethod(
      "setSystemStatus",
      [CubiqTS.ENCODABLE(CubiqTS.SystemControlImpl)],
      this.setSystemStatus.bind(this),
      this.VALUE,
    );

    this.cubiqWorker
      .getEncodableObservable(CubiqTS.SysCtrlEventImpl.name)
      .subscribe((sysCtrlEvent: CubiqTS.SysCtrlEventImpl) => {
        this.processSystemControlEvent(sysCtrlEvent);
      });
  }

  private processSystemControlEvent(event: CubiqTS.SysCtrlEventImpl) {
    this.base.mapItem(event.systemControl);
    this.fireModelUpdateEvent(event.systemControl);
  }

  setSystemStatus(systemControl: CubiqTS.SystemControlImpl): Promise<void> {
    let request: SystemControlUpdateRequestImpl = new SystemControlUpdateRequestImpl();
    request.systemControl = systemControl;
    return this.cubiqWorker.postServiceRequest(request);
  }
}
